import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M5 11q-.825 0-1.413-.588A1.92 1.92 0 0 1 3 9V5q0-.825.588-1.413A1.92 1.92 0 0 1 5 3h4q.825 0 1.413.588T11 5v4q0 .825-.588 1.413A1.92 1.92 0 0 1 9 11zm0 10q-.825 0-1.413-.588A1.92 1.92 0 0 1 3 19v-4q0-.825.588-1.413A1.92 1.92 0 0 1 5 13h4q.825 0 1.413.588T11 15v4q0 .825-.588 1.413A1.92 1.92 0 0 1 9 21zm10-10q-.825 0-1.413-.588A1.92 1.92 0 0 1 13 9V5q0-.825.588-1.413A1.92 1.92 0 0 1 15 3h4q.825 0 1.413.588T21 5v4q0 .825-.588 1.413A1.92 1.92 0 0 1 19 11zm0 10q-.825 0-1.413-.588A1.92 1.92 0 0 1 13 19v-4q0-.825.588-1.413A1.92 1.92 0 0 1 15 13h4q.825 0 1.413.588T21 15v4q0 .825-.588 1.413A1.92 1.92 0 0 1 19 21zM5 9h4V5H5zm10 0h4V5h-4zm0 10h4v-4h-4zM5 19h4v-4H5z"
    }, null, -1)
  ]))]))
}
export default { render: render }